import React, { useEffect, useMemo, useState } from "react";
import { Grid, Button } from "@mui/material";
import AddBox from "@mui/icons-material/AddBox";

// Non-Flying Assignment Form Imports
import { INonFlyingAssignment } from "@vmosolutions/oc-interfaces";
import { NonFlyingAssignmentForm, initialValues } from "../Forms/NonFlyingAssignmentForm"; //, initialValues as newNonFlyingAssignment
import { IEmbeddedFormState } from "../PairingEditorWindow";

interface INFATabProps {
  id: string;
  className: string;
  nonFlyingAssignment: INonFlyingAssignment; // incoming event for edit
  updateNonFlyingAssignment: (nonFlyingAssignment: INonFlyingAssignment, eventType: string) => void; // outgoing edited event
  setEmbeddedFormStates: React.Dispatch<React.SetStateAction<IEmbeddedFormState>>;
  /** React setState for the embedded initial value of nonFlyingAssignment */
  setSelectedNonFlyingAssignment: (nonFlyingAssignment: INonFlyingAssignment | null) => void;
}

/**
 * Pairing Events tab contains forms used for creation and editing of non-flying assignments and positioning flights
 * @param props -
 */
export const NonFlyingAssignmentsTab = (props: INFATabProps): JSX.Element => {
  const {
    id,
    className,
    nonFlyingAssignment,
    updateNonFlyingAssignment,
    setEmbeddedFormStates,
    setSelectedNonFlyingAssignment,
  } = props;
  const [initialFormValues, setInitialFormValues] = useState<INonFlyingAssignment>(initialValues);

  // consider item new if there is no _id or tempId present!
  const isNew = !initialFormValues?._id && !initialFormValues?._tempId;

  const mosaicPane = useMemo(() => {
    return id ? document.getElementById(`${id}-panel`) : null;
  }, [id]);

  // If a nonFlyingAssignment is passed through props, set it as initial form values.
  useEffect(() => {
    setInitialFormValues(nonFlyingAssignment);
  }, [nonFlyingAssignment]);

  return (
    <Grid container direction="column" className={className}>
      <Grid item className="event_actions">
        <Grid container direction="row">
          <Button className="action_btn" onClick={() => setInitialFormValues(initialValues)} disabled={isNew}>
            <AddBox /> Add New
          </Button>
        </Grid>
      </Grid>

      <Grid item>
        <NonFlyingAssignmentForm
          isNew={isNew}
          mosaicPane={mosaicPane}
          nonFlyingAssignment={initialFormValues}
          updateNonFlyingAssignment={(nonFlyingAssignment: INonFlyingAssignment) => {
            updateNonFlyingAssignment(nonFlyingAssignment, "nonFlight");
            setInitialFormValues(nonFlyingAssignment);
          }}
          setEmbeddedFormStates={setEmbeddedFormStates}
          setSelectedNonFlyingAssignment={setSelectedNonFlyingAssignment}
        />
      </Grid>
    </Grid>
  );
};
